import { useRef } from 'react'
import _ from 'lodash'
import { useSetAtom } from 'jotai'
import { safeAwait } from '@vzmi/component_ec_nodejs_util/dist/lib/FetchDataUtil'
import { delay } from '@vzmi/component_ec_nodejs_util/dist/lib/renderUtil'
import { throwIfError } from '../../../../../lib/reserviceErrorHelpers'
import { corsStatusAtom } from './useSteps'
import useCloneRequestController from './useCloneRequestController'
import { getCustomError } from '../helpers'
import { CAUSE_CODE } from '../constants'

const COOLDOWN_MS = 1000

const useCorsCheck = () => {
  const { signal, getIsAborted, fetchWithAbort } = useCloneRequestController()
  const runningRef = useRef(false)
  const setCorsStatus = useSetAtom(corsStatusAtom)

  const trigger = async () => {
    const [error, response] = await safeAwait(
      fetchWithAbort('https://tw.buy.yahoo.com/status.html', { signal })
    )
    if (error) {
      setCorsStatus(false)
      const isAborted = getIsAborted(signal, error)
      const errors = {
        httpError: isAborted ? error : getCustomError(CAUSE_CODE.EXTERNAL_CLONE_CORS_ERROR, error)
      }
      throwIfError(errors)
    }

    const status = _.get(response, 'status')
    const text = await response.text()
    const nextCors = status === 200 || text.includes('ok')
    setCorsStatus(nextCors)
    return { cors: nextCors, status, response }
  }

  /**
   * Cooldown after completion：一次 CORS 檢查從開始到「fetch 結束後再等 COOLDOWN_MS」期間，runningRef 為 true。
   * 這段期間重入的呼叫不會再發請求，回傳 { skipped: true }。
   */
  const triggerThrottled = async () => {
    if (runningRef.current) {
      return { skipped: true }
    }

    runningRef.current = true
    const [error, result] = await safeAwait(trigger())
    await delay(COOLDOWN_MS)
    runningRef.current = false
    if (error) {
      return { skipped: false, error, cors: false }
    }

    return { skipped: false, ...result }
  }

  return { trigger, triggerThrottled }
}

export default useCorsCheck
